export class SignalBufferColumnModeProvider {
  constructor(signalBuffer) {
    this.signalBuffer = signalBuffer;
  }

  createPointBuffer(plotWidthInPx, graphicDataBufferLength) {
    const graphicBufferLength = plotWidthInPx;
    this.signalBuffer.graphicBufferLength = graphicBufferLength;
    this.signalBuffer.pointsPerPixel = graphicDataBufferLength / this.signalBuffer.settings.plotSize.width;

    (this.signalBuffer.columnsBuffer = []).length = graphicBufferLength;
    for (let columnIndex = 0; columnIndex < graphicBufferLength; ++columnIndex) {
      this.signalBuffer.columnsBuffer[columnIndex] = {
        min: 0,
        max: 0
      };
    }
    const pointBufferLength = graphicBufferLength * 4;
    this.signalBuffer.pointBuffer = new Float32Array(pointBufferLength);
    for (let i = 0, j = 0; i < pointBufferLength; i += 4, ++j) {
      this.signalBuffer.pointBuffer[i] = j;
      this.signalBuffer.pointBuffer[i + 2] = j;
    }
  }

  updatePixelsPointsValues() {
    if (this.signalBuffer.actualGraphicDataBufferLength == 0) {
      return;
    }
    const dataLength = this.signalBuffer.actualGraphicDataBufferLength;
    let minMaxValue;
    let minY = null;
    let maxY = null;

    let data = this.signalBuffer.dataBuffer[0];
    let lastGraphicIndex = 0;
    if (data == null) {
      this.signalBuffer.pointBuffer[1] = 0;
      this.signalBuffer.pointBuffer[3] = 0;
    } else {
      data = this.signalBuffer.convertValueToPixels(data);
      this.signalBuffer.columnsBuffer[0] = {
        min: data,
        max: data + 1
      };
      this.signalBuffer.pointBuffer[1] = this.signalBuffer.columnsBuffer[0].min;
      this.signalBuffer.pointBuffer[3] = this.signalBuffer.columnsBuffer[0].max;
    }

    for (let pointIndex = 1; pointIndex < dataLength; ++pointIndex) {
      const dataIndex = this.signalBuffer.graphicDataBuffer[pointIndex].dataIndex;
      const graphicIndex = this.signalBuffer.graphicDataBuffer[pointIndex].graphicIndex;

      data = this.signalBuffer.dataBuffer[dataIndex];
      const pointBufferIndex = graphicIndex * 4;
      if (data == null) {
        this.signalBuffer.pointBuffer[pointBufferIndex + 1] = 0;
        this.signalBuffer.pointBuffer[pointBufferIndex + 3] = 0;
      } else {
        data = this.signalBuffer.convertValueToPixels(data);
        if (graphicIndex == lastGraphicIndex) {
          // old index
          minMaxValue = this._calculateMinMaxToOldIndex(data, graphicIndex);
          minY = minMaxValue.min;
          maxY = minMaxValue.max;
        } else {
          // New index
          minMaxValue = this._calculateMinMaxToNewIndex(data, lastGraphicIndex);
          minY = minMaxValue.min;
          maxY = minMaxValue.max;
        }
        if (maxY == minY) {
          maxY = minY + 1;
        }
        this.signalBuffer.columnsBuffer[graphicIndex] = {
          min: minY,
          max: maxY
        };
        this.signalBuffer.pointBuffer[pointBufferIndex + 1] = minY;
        this.signalBuffer.pointBuffer[pointBufferIndex + 3] = maxY;
      }
      lastGraphicIndex = graphicIndex;
    }
  }

  putData(data) {
    let nomodGraphicDataIndex = this.signalBuffer.graphicDataIndex + 1;
    this.signalBuffer.graphicDataIndex = nomodGraphicDataIndex % this.signalBuffer.graphicDataBufferLength;
    if (nomodGraphicDataIndex != this.signalBuffer.graphicDataIndex) {
      this.signalBuffer.startGraphicIndex = this.signalBuffer.graphicIndex;
      this.signalBuffer.startGraphicDataIndex = this.signalBuffer.graphicDataIndex;
    }

    if (this.signalBuffer.graphicIndex < 0) {
      if (data == null) {
        this.signalBuffer.columnsBuffer[0] = {
          min: null,
          max: null
        };
        this.signalBuffer.pointBuffer[1] = 0;
        this.signalBuffer.pointBuffer[3] = 0;
        this.signalBuffer.isLastNull = true;
      } else {
        const dataPixels = this.signalBuffer.convertValueToPixels(data);
        this.signalBuffer.columnsBuffer[0] = {
          min: dataPixels,
          max: dataPixels + 1
        };
        this.signalBuffer.pointBuffer[1] = this.signalBuffer.columnsBuffer[0].min;
        this.signalBuffer.pointBuffer[3] = this.signalBuffer.columnsBuffer[0].max;
        this.signalBuffer.sectorIndex = 0;
        this.signalBuffer.isLastNull = false;
        this.signalBuffer.notNullSectors = [
          {
            begin: 0,
            end: 0
          }
        ];
      }
      this.signalBuffer.graphicIndex = 0;
    } else {
      let newData = data == null ? null : this.signalBuffer.convertValueToPixels(data);
      // draw by columns
      let currGraphicIndex = (Math.floor(this.signalBuffer.graphicDataIndex / this.signalBuffer.pointsPerPixel) + this.signalBuffer.startGraphicIndex) % this.signalBuffer.graphicBufferLength;
      if (currGraphicIndex == 0) {
        this.signalBuffer.sectorIndex = 0;
      }
      let minMaxValue;
      let minY, maxY;
      if (currGraphicIndex == this.signalBuffer.graphicIndex) {
        // old index
        if (newData != null) {
          minMaxValue = this._calculateMinMaxToOldIndex(newData, currGraphicIndex);
          minY = minMaxValue.min;
          maxY = minMaxValue.max;
        }
      } else {
        // New index
        if (newData != null) {
          minMaxValue = this._calculateMinMaxToNewIndex(newData, this.signalBuffer.graphicIndex);
          minY = minMaxValue.min;
          maxY = minMaxValue.max;
        }
        this.signalBuffer.graphicIndex = currGraphicIndex;
      }

      if (newData != null) {
        if (maxY == minY) {
          maxY = minY + 1;
        }
        this.signalBuffer.columnsBuffer[this.signalBuffer.graphicIndex] = {
          min: minY,
          max: maxY
        };
        this.signalBuffer.pointBuffer[currGraphicIndex * 4 + 1] = minY;
        this.signalBuffer.pointBuffer[currGraphicIndex * 4 + 3] = maxY;
        if (this.signalBuffer.isLastNull) {
          this.signalBuffer.sectorIndex = this.signalBuffer._pushIndexToNotNullSectors(this.signalBuffer.graphicIndex);
          this.signalBuffer.isLastNull = false;
        } else {
          if (this.signalBuffer.graphicIndex > this.signalBuffer.notNullSectors[this.signalBuffer.sectorIndex].end) {
            this.signalBuffer.notNullSectors[this.signalBuffer.sectorIndex].end = this.signalBuffer.graphicIndex;
          }
        }
      } else {
        if (!this.signalBuffer.isLastNull) {
          this.signalBuffer.notNullSectors[this.signalBuffer.sectorIndex].end = this.signalBuffer.graphicIndex == 0 ? this.signalBuffer.graphicBufferLength - 1 : this.signalBuffer.graphicIndex - 1;
        }
        this.signalBuffer.isLastNull = true;
        this.signalBuffer.pointBuffer[currGraphicIndex * 4 + 1] = 0;
        this.signalBuffer.pointBuffer[currGraphicIndex * 4 + 3] = 0;
      }
    }
  }

  _calculateColumnValue(data, graphicIndex, columnValue) {
    columnValue.min = this.signalBuffer.columnsBuffer[graphicIndex].min == null ? data : this.signalBuffer.columnsBuffer[graphicIndex].min;
    columnValue.max = this.signalBuffer.columnsBuffer[graphicIndex].max == null ? data : this.signalBuffer.columnsBuffer[graphicIndex].max;
    if (columnValue.min > data) {
      columnValue.min = data;
    } else if (columnValue.max < data) {
      columnValue.max = data;
    }
  }

  _calculateMinMaxToOldIndex(data, graphicIndex) {
    let minValue = this.signalBuffer.columnsBuffer[graphicIndex].min == null ? data : this.signalBuffer.columnsBuffer[graphicIndex].min;
    let maxValue = this.signalBuffer.columnsBuffer[graphicIndex].max == null ? data : this.signalBuffer.columnsBuffer[graphicIndex].max;
    if (minValue > data) {
      minValue = data;
    }
    if (maxValue < data) {
      maxValue = data;
    }
    return {
      min: minValue,
      max: maxValue
    };
  }

  _calculateMinMaxToNewIndex(data, graphicIndex) {
    let minValue = data;
    let maxValue = data + 1;
    // Try remove space by height between columns (current and previous)
    if (maxValue < this.signalBuffer.columnsBuffer[graphicIndex].min) {
      maxValue = this.signalBuffer.columnsBuffer[graphicIndex].min;
    } else if (minValue > this.signalBuffer.columnsBuffer[graphicIndex].max) {
      minValue = this.signalBuffer.columnsBuffer[graphicIndex].max;
    }
    return {
      min: minValue,
      max: maxValue
    };
  }
}